// 宣言
const activeClass = 'js-active';

/**
 * aemプラグインの初期化
 */
const initAemPlugins = () => {

    // inview
    $('.js-inview').aemInview({
        // offset: '5%',
        // test: 'aqua',
        scrollEnd: true,
    });

    // 動画に対してラッパーを作成
    $('.aem-post').find('iframe').wrap('<div class="movie-wrapper"></div>');

    // スムーススクロール
    $('a[href^="#"]').not('.no-scroll').aemSmoothScroll();
}

/**
 * ページTOPへの追従ボタン初期化
 */
const initPageToTop = () => {
    const $pagetop = $('.js-pagetop');

    if ($(window).scrollTop() > 0) {
        $pagetop.addClass(activeClass);
    } else {
        $pagetop.removeClass(activeClass);
    }
}

/**
 * グローバルメニューの初期化
 */
const initGlobalMenu = () => {

    // メニュー開く
    $('.js-menu-toggle').on('click', function(){
        $('.js-search-menu').fadeOut(300);
        $('.js-search-modal').removeClass(activeClass);
        $('.js-menu-toggle').toggleClass(activeClass);
        $('.js-nav').fadeToggle(300);
    })

    // メニュー閉じる
    $('.js-nav-close').on('click', function(){
        $('.js-nav').fadeOut(300);
        $('.js-menu-toggle').removeClass(activeClass);
    });
}

/**
 * 検索窓の初期化
 */
const initSearchMenu = () => {

    $('.js-search-modal').on('click', function(){

        if($('.js-menu-toggle').hasClass(activeClass)) {
            // グローバルメニューが開いている場合は閉じる
            $('.js-menu-toggle').removeClass(activeClass);
            $('.js-nav').fadeOut(300);
        }

        $(this).toggleClass(activeClass);
        $('.js-search-menu').fadeToggle(300);

    });

    $('.js-search-menuーclose').on('click', function(){
        $('.js-search-menu').fadeOut(300);
        $('.js-search-modal').removeClass(activeClass);
    });
}

/**
 *  アコーディオンの初期化
 */
const  initAccordion = () => {

    // クラス名定義
    const accordionClass = 'js-accordion';
    const accordionTitleClass = 'js-accordion-title';
    const className = 'js-open';

    // titleごとに処理を実行
    $('.' + accordionClass).each(function() {
        const $this = $(this).find('.' + accordionTitleClass);
        const $body = $this.next();

        // あらかじめクラスが付いていたら初期表示でオープン
        if ($this.hasClass(className)) {
            $body.slideToggle(300, 'linear');
        }

        // タイトルをクリックしたら開閉する
        $this.on('click', function() {
            $this.toggleClass(className);
            $body.slideToggle(300, 'linear');
        });
    });
}

/**
 * セレクトボックスのプレースホルダー対応
 */
const initSelectBoxPlaceholder = () => {

    // 初期選択時の処理
    $('select.js-select-placeholder').each(function() {
        const val = $(this).val();
        if(val == "all") {
            // 初期表示がvalueがallの場合は文字色を変更する
            $(this).addClass('no-select');
        } else {
            $(this).removeClass('no-select');
        }
    });

    // 変更時の処理
    $('select.js-select-placeholder').on('change', function() {
        const val = $(this).val();
        if(val == "all") {
            // 初期表示がvalueがallの場合は文字色を変更する
            $(this).addClass('no-select');
        } else {
            $(this).removeClass('no-select');
        }
    });
}

/**
 * 共通処理の初期化
 */
const init = () => {
    initAemPlugins();
    $(window).on('scroll', initPageToTop);
    initGlobalMenu();
    initSearchMenu();
    initAccordion();
    initSelectBoxPlaceholder();
}

$(function () {
    init();
})
